module.exports = __webpack_public_path__ + "static/img/bg.745f45b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img/bg.png
// module id = UiNM
// module chunks = 0